import { createLead } from 'src/app/client/models/leadForm';
import { SET_ONBOARDING_VALUES } from 'src/app/state/actions/types';
import type { Dispatch, RootState } from 'src/app/state/store';

export interface LeadAttributes {
  email: string;
  source: string;
  address?: string;
  doctorName?: string;
  phone?: string;
  specialty?: string;
  zipCode?: string;
}

export function createLeadAction(body: LeadAttributes) {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const state = getState();
    const { client } = state;

    const lead = await createLead(client, body);
    const leadAccountId = lead?.data?.data?.attributes?.account || '';
    dispatch({
      type: SET_ONBOARDING_VALUES,
      values: {
        leadAccountId,
      },
    });
    return leadAccountId;
  };
}
